// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"10816166","453":"4e717d7f","455":"bc2466b7","833":"eaf8662b","948":"392f63ee","977":"cad6442f"}[chunkId] + ".chunk.js";
};